import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md px-3 py-2 text-base md:text-sm text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "relative isolate box-border border-[0.5px] border-transparent bg-secondary",
          "before:inset-0 before:border-t-[0.5px] before:border-white/20 before:h-full before:w-full before:absolute before:rounded-[inherit] before:bg-gradient-to-b before:from-white/[0.03] before:to-black/[0.03] before:pointer-events-none",
          "dark:before:top-[-0.5px] dark:before:w-[calc(100%+1px)] dark:before:start-[-0.5px] dark:before:end-[-0.5px]",
          "after:absolute after:inset-[-0.5px] after:rounded-[inherit] after:pointer-events-none after:-z-10 after:border-[0.5px] after:border-black/20 dark:after:border-white/10 after:shadow-sm",
          "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring transition-all duration-300",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
